import { render } from "./AdminListPage.vue?vue&type=template&id=604992a3"
import script from "./AdminListPage.vue?vue&type=script&lang=js"
export * from "./AdminListPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__